if (!customElements.get('dhuni-campaign-popup')) {
  customElements.define('dhuni-campaign-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      const seenKey = 'dhuni:renewal-500-popup:seen';
      const hasSeen = () => {
        if (window[seenKey]) return true;
        for (const storage of ['localStorage', 'sessionStorage']) {
          try {
            if (window[storage].getItem(seenKey) === '1') return true;
          } catch (_) { /* Storage may be unavailable in private browsing. */ }
        }
        return false;
      };
      const remember = () => {
        window[seenKey] = true;
        for (const storage of ['localStorage', 'sessionStorage']) {
          try { window[storage].setItem(seenKey, '1'); } catch (_) { /* Keep the in-page fallback. */ }
        }
      };
      if (hasSeen()) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      window.addEventListener('pageshow', (event) => {
        if (event.persisted && this.dialog.open) this.dialog.close();
      }, options);
      this.querySelector('button').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);

      const video = this.querySelector('video');
      const media = video || this.querySelector('img');
      let dismissed = false;
      this.dialog.addEventListener('close', () => {
        dismissed = true;
        video?.pause();
      }, options);
      // Wait for usable media so a failed download never leaves an empty overlay.
      const show = () => {
        const ready = video ? video.readyState >= 2 : media.naturalWidth > 0;
        if (!this.isConnected || !ready || dismissed) return;
        if (video) this.dialog.style.setProperty('--media-ratio', video.videoWidth / video.videoHeight);
        if (!this.dialog.open) {
          if (hasSeen()) return;
          this.dialog.showModal();
          remember();
        }
        if (video) {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
          else video.play().catch(() => {});
        }
      };
      media.addEventListener(video ? 'loadeddata' : 'load', show, options);
      if (video) {
        const mobile = window.matchMedia('(max-width: 749px)');
        const selectVideo = () => {
          if (dismissed) return;
          const source = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
          if (video.getAttribute('src') === source) return;
          video.src = source;
          video.load();
        };
        mobile.addEventListener('change', selectVideo, options);
        selectVideo();
      }
      show();
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
